import {Component, computed, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {MetaDataListComponent} from "@app/template-editor/components/meta-data-list/meta-data-list.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {ExportNode, isValidExternalId, getTemplateNodeClassLabel} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-export-inspector",
    templateUrl: "./export-inspector.component.html",
    styleUrl: "./export-inspector.component.scss",
    imports: [MetaDataListComponent, InspectorSectionComponent, ValueSlotComponent],
})
export class ExportInspectorComponent extends BaseInspectorComponent<ExportNode<unknown>> {
    readonly $class = computed(() => getTemplateNodeClassLabel(this.$node()).replace("Export", "Output"))
    readonly $isValidExternalId = signal(isValidExternalId)
}
